import { Component } from '@angular/core'
import { VODGridComponent } from '../../widgets/vod-grid/vod-grid.component'
import { ProjectCMSWidgetType, VODGridWidget, VODTitleWidget } from 'htv-lib'
import { HeaderComponent } from '../../layout/components/header/header.component'
import { VODSummaryComponent } from '../../widgets/vod-summary/vod-summary.component'

@Component({
  selector: 'app-vod-catalog',
  standalone: true,
  imports: [VODGridComponent, HeaderComponent, VODSummaryComponent],
  templateUrl: './vod-catalog.component.html',
  styleUrls: ['./vod-catalog.component.scss'],
})
export class VODCatalogComponent {
  vodgridconfig: VODGridWidget = {
    type: ProjectCMSWidgetType.VOD_GRID,
    name: 'DefaultVODMenu',
    width: 1280,
    height: 920,
    x: 0,
    y: 160,
  }

  vodsummaryconfig: VODTitleWidget = {
    type: ProjectCMSWidgetType.VOD_TITLE,
    name: 'DefaultVODMenu',
    width: 640,
    height: 920,
    x: 1280,
    y: 160,
  }
}
